import React, { useMemo } from "react";
import { Layout, Menu, Typography, Button, Space } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { LogoutOutlined, TeamOutlined, DashboardOutlined } from "@ant-design/icons";
import { clearAdminSession, getAdminUserInfo } from "../auth/auth.storage";

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const AdminLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const me = getAdminUserInfo();

  const selectedKeys = useMemo(() => {
    if (location.pathname.startsWith("/users")) return ["users"];
    return ["dashboard"];
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        theme="light"
        width={264}
        style={{ borderRight: "1px solid #e6e6ea" }}
      >
        <div style={{ padding: 16, borderBottom: "1px solid #e6e6ea" }}>
          <div style={{ fontWeight: 800, letterSpacing: 0.4, color: "#111114" }}>
            ADMIN PANEL
          </div>
          <Text style={{ color: "rgba(17,17,20,0.65)" }}>
            {me?.userName} · {me?.role}
          </Text>
        </div>

        <Menu
          theme="light"
          mode="inline"
          selectedKeys={selectedKeys}
          items={[
            {
              key: "dashboard",
              icon: <DashboardOutlined />,
              label: "Dashboard",
              onClick: () => navigate("/"),
            },
            {
              key: "users",
              icon: <TeamOutlined />,
              label: "Quản lý User",
              onClick: () => navigate("/users"),
            },
          ]}
        />
      </Sider>

      <Layout>
        <Header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            borderBottom: "1px solid #e6e6ea",
          }}
        >
          <Space>
            <Button
              icon={<LogoutOutlined />}
              onClick={() => {
                clearAdminSession();
                navigate("/login", { replace: true });
              }}
            >
              Đăng xuất
            </Button>
          </Space>
        </Header>
        <Content style={{ padding: 20 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;

